import React, { useState } from "react";

const Hero = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div className="hero-container">
        <div className="hero-wrapper">
          <div className="content">
            <div className="text-container">
              <p className="subtitle">7.800+ behandelingen uitgevoerd</p>
              <h1>Behoud je natuurlijke schoonheid met tijdloze verzorging</h1>
              <p className="paragraph">
                Versterk je huid, verminder rimpels en krijg een frisse, egale
                teint met behandelingen die je natuurlijke uitstraling behouden.
              </p>
              <button
                className="btn"
                onClick={() => (window.location.href = "/afspraak")}
              >
                Afspraak maken →
              </button>
            </div>
          </div>
        </div>
        <div className="show-off">
          <a href="#modal">
            <img
              src="/images/show_icon.png"
              alt="Show promotion Queen Center"
              onClick={() => setModalOpen(true)}
              style={{ cursor: "pointer" }}
            />
          </a>
        </div>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setModalOpen(false)}>
              &times;
            </button>
            <div className="video-wrapper">
              <iframe
                src="https://player.vimeo.com/video/308213903"
                title="Promotional Video"
                width="100%"
                height="500"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Hero;
